import { hostname } from '../config';

const localApiUrl = process.env.VUE_APP_LOCAL_API_URL || '/';
const productionApiUrl = process.env.VUE_APP_API_ENDPOINT || '/';

export const apiUrl = hostname === 'localhost' ? localApiUrl : productionApiUrl;

export const apiPath = 'api';
